import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { withRouter, Route, Switch , useLocation, useHistory } from "react-router-dom";
import SectionHeader from "../../../../components/section-header/section-header";
import AdminRoleCreatePanelNew from "../admin-role-create-panel-new/admin-role-create-panel-new";
import AdminDynamicFieldsPage from "../task-types/dynamic-fields/dynamic-fields-page/admin-dynamic-fields-page";
import AdminSubDepartmentCreatePanel from "../admin-subdepartment/admin-subdepartment-create-panel";
import AdminSubDepartmentEditPanel from "../admin-subdepartment/admin-subdepartment-edit-panel";
import AdminMainTable from "../admin-main-table/AdminMainTable";
import AdminNavbar from "../admin-tab-control/admin-tab-control";
import { selectUser } from "../../../../redux/user/user-selector";
import { FixRolePrivileges } from "../../../../services/api/role-privilege-api";
import CreateEditWorkflowRouter from "../workflow/create-edit-workflow/create-edit-workflow-router";
import AdminDepartmentCreatePanelNew from "../admin-department-create-panel/admin-department-create-panel-new";
import AdminGroupCreatePanelNew from "../admin-group-create-panel/admin-group-create-panel-new";
import AdminUserCreatePanelNew from "../admin-user-create-panel/admin-user-create-panel-new";
import TemplateCreationPanelNew from "../templates/template-creation/template-creation-new";
import TemplateTaskCreationPanelNew from "../templates/template-task-creation/template-task-creation-new";
import FieldRepositoryTable from "../field-repository/field-repository-table";
import { TaskTypeNew } from "../task-types/new-task-type/task-type-new";
import "./admin-page.scss";

const AdminPage = () => {
  const history = useHistory();
  const location = useLocation();
  const user = useSelector(selectUser);
  const privileges = user?.privileges ?? {};

  const [tab, setTab] = useState("");
  const [subTab, setSubTab] = useState("");

  useEffect(() => {
    const checkPermission = () => {
      try {
        let privilegeName = [
          "User",
          "Group",
          "Role",
          "Role Privileges",
          "Department",
          "Log Activity",
          "Notifications",
          "Templates",
          "Task Types",
        ];
        let tabs = [
          "Users",
          "Groups",
          "Roles",
          "Role Privileges",
          "Organization",
          "Log Activity",
          "Notifications",
          "Templates",
          "Task Types",
        ];

        let activeTabIndex = privilegeName.findIndex((name) => {
          return privileges[name]?.view === true;
        });

        if (activeTabIndex === -1) activeTabIndex = 0;

        setTab(tabs[activeTabIndex]);
      } catch (err) {
        FixRolePrivileges().then(
          async (result) => {
            console.log("Role Privileges Updated", result);
            window.location.reload(false);
          },
          (error) => {
            console.log(error);
          }
        );
      }
    };

    const rememberTab = () => {
      history.location.search.includes("users") && setTab("Users");
      history.location.search.includes("groups") && setTab("Groups");
      history.location.search.includes("roles") && setTab("Roles");
      history.location.search.includes("templates") && setTab("Templates");
      history.location.search.includes("task-types") && setTab("Task Types");
      history.location.search.includes("workflows") && setTab("Workflow");
      history.location.search.includes("Field Repository") && setTab("Field Repository");

      if (history?.location?.search?.toLowerCase().includes("organization")) {
        setTab("Organization");
        if (history.location.search.toLowerCase().includes("subdepartments")) {
          setSubTab("SubDepartments");
        } else {
          setSubTab("Departments");
        }
      }
    };

    history.location.search.length < 1 ? checkPermission() : rememberTab();
  }, [history, privileges]);

  return (
    <div className="admin-page">
      <SectionHeader
        title="Admin"
        searchEnabled={location.pathname === "/admin"}
      />
      <Helmet>
        <title>TRIYO · Admin</title>
      </Helmet>
      <Route exact path="/admin">
        <AdminNavbar setCurrentTab={setTab} currentTab={tab} />
        <AdminMainTable currentTab={tab} currentSubTab={subTab} />
      </Route>
      <Route path="/admin/users">
        <AdminUserCreatePanelNew />
      </Route>
      <Route path="/admin/groups">
         <AdminGroupCreatePanelNew />
      </Route>
      <Route path="/admin/roles">
        <AdminRoleCreatePanelNew />
      </Route>
      <Route path="/admin/organization/departments">
        <AdminDepartmentCreatePanelNew />
      </Route>
      <Route path="/admin/organization/subdepartments/create">
        <AdminSubDepartmentCreatePanel />
      </Route>
      <Route path="/admin/organization/subdepartments/edit">
        <AdminSubDepartmentEditPanel />
      </Route>
      <Route path="/admin/templates/create">
        <TemplateCreationPanelNew />
      </Route>
      <Route path="/admin/templates/edit">
        <TemplateCreationPanelNew />
      </Route>
      <Route path="/admin/templates/tasks">
        <TemplateTaskCreationPanelNew />
      </Route>
      <Route path="/admin/templates/subtasks">
        <TemplateTaskCreationPanelNew />
      </Route>
      <Route path="/admin/task-types/dynamic-fields">
        <AdminDynamicFieldsPage />
      </Route>
      <Route path="/admin/task-types/task-type">
        <TaskTypeNew />
      </Route>
      <Switch>
        <Route
          exact
          path="/admin/workflow/create"
          render={(props) => <CreateEditWorkflowRouter {...props} />}
        />
        <Route
          exact
          path="/admin/workflow/edit/:id"
          render={(props) => <CreateEditWorkflowRouter {...props} />}
        />
      </Switch>
      <Route path="/admin/field-repository/create">
        <FieldRepositoryTable />
      </Route>
    </div>
  );
};

export default withRouter(AdminPage);
